import profiles from "./rust/stack-limits/profiles.json";

export type ResourceLimitProfile = keyof typeof profiles.profiles;

export const RESOURCE_LIMIT_PROFILES = Object.keys(
  profiles.profiles
) as readonly ResourceLimitProfile[];

export const DEFAULT_RESOURCE_LIMIT_PROFILE =
  profiles.default as ResourceLimitProfile;

export const EXPLORE_MANAGED_AI_CREDIT_CENTS = 5_000;
export const MAX_CUSTOM_DOMAINS_PER_TENANT = 5;

export type StackLimits = {
  spacesPerTenant: number;
  storageBytesPerLabel: number;
  storageBytesPerTenant: number;
  concurrentExecutionsPerTenant: number;
  workflowsPerSpace: number;
  workflowsPerTenant: number;
  monthlyTinesUnitsLimit: number | null;
};

const limitsByProfile: Record<ResourceLimitProfile, StackLimits> =
  profiles.profiles;

export function parseResourceLimitProfile(value: string): ResourceLimitProfile {
  if ((RESOURCE_LIMIT_PROFILES as readonly string[]).includes(value)) {
    return value as ResourceLimitProfile;
  }
  throw new Error(
    `RESOURCE_LIMIT_PROFILE must be one of ${RESOURCE_LIMIT_PROFILES.join(", ")}, got “${value}”`
  );
}

export function resourceLimitProfileFromEnv(): ResourceLimitProfile {
  return parseResourceLimitProfile(
    process.env.RESOURCE_LIMIT_PROFILE ?? DEFAULT_RESOURCE_LIMIT_PROFILE
  );
}

export function stackLimits(profile: ResourceLimitProfile): StackLimits {
  return limitsByProfile[profile];
}
